import store from '../vuex/store.js'
import api from '../request/apis.js';
import { Dialog } from 'vant';
export const commonObj = {
    //检查角色权限
    checkRole(roleArr){
        let ret=false;
        let roleIdList = store.state.stateObject.userInfo.roleList;
          roleIdList.forEach((element) => {
            if (roleArr.indexOf(element.roleId) > -1) {
              ret = true;
            }
          });
        return ret;
      },
    DateDiff(sDate1, sDate2) {    //sDate1和sDate2是2002-12-18格式  
        var aDate, oDate1, oDate2, iDays
        aDate = sDate1.split("-")
        oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])    //转换为12-18-2002格式  
        aDate = sDate2.split("-")
        oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
        iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)    //把相差的毫秒数转换为天数  
        return iDays
    },
    getRegionData() {
        let regionList = JSON.parse(localStorage.getItem("region"));
        regionList.forEach(function (item) {
            item.text = item.name;
            item.children = item.child;
            item.children.forEach(function (item2) {
                item2.text = item2.name;
                item2.children = item2.child;
                item2.children.forEach(function (item3) {
                    item3.text = item3.name;
                });
            });
        });
        regionList.forEach(function (item) {
            item.text = item.name;
            item.children = item.child;
            item.children.forEach(function (item2) {
                item2.children.unshift({ text: "全部", children: [{ text: "全部" }] });
            });
        });
        regionList.forEach(function (item) {
            item.children.unshift({ text: "全部", children: [{ text: "全部" }] });
        });
        return regionList
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp|svg|ico|tiff?)$/i.test(url);
    },
    getDraftListStateMap() {
        return [
            { text: "全部", value: null },
            // { text: "未发起", value: 0 },
            { text: "审核中", value: 1 },
            { text: "审核通过", value: 2 },
            { text: "审核未通过", value: 3 },
            { text: "已撤回", value: 4 }
        ]
    },
 getDraftContractStateMap(state) {
      if (state == 0) return "未发起";
      if (state == 1) return "审核中";
      if (state == 2) return "审核通过";
      if (state == 3) return "审核拒绝";
      if (state == 4) return "已撤回";
      return "";
    },
    getDraftContractStateStyle(state) {
    let style = {
        fontSize: "12px",
        color: "#666",
        background: "#f2f2f2",
        padding: "2px 8px",
        borderRadius: "10px",
        marginLeft: "8px",
        flexShrink: "0",
        display: "inline-block"
    };
    if (state == 1) {
        style.color = "#ff8f00";
        style.background = "#fff3e0";
    } else if (state == 2) {
        style.color = "#07c160";
        style.background = "#e6f9ed";
    } else if (state == 3) {
        style.color = "#ee0a24";
        style.background = "#ffecec";
    }
    return style;
},
    formatDate(date) {
        if (date == null) {
            return "暂无";
        }
        // ${date.getFullYear()}/
        return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    //时分秒转换日期
    formatDateToDay(dateStr) {
        if (dateStr == null || dateStr == "") {
            return "-"
        }
        var date = new Date(dateStr); //转换
        //重组
        var datetime =
            date.getFullYear() +
            "-" + //年
            (date.getMonth() + 1 > 9
                ? date.getMonth() + 1
                : "0" + (date.getMonth() + 1)) +
            "-" + //月
            (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()); //日
        return datetime;
    },
    //时分秒转换日期
    formatDateToMonth(dateStr) {
        if (dateStr == null || dateStr == "") {
            return "-"
        }
        var date = new Date(dateStr); //转换
        //重组
        var datetime =
            date.getFullYear() +
            "-" + //年
            (date.getMonth() + 1 > 9
                ? date.getMonth() + 1
                : "0" + (date.getMonth() + 1)) //月
        return datetime;
    },
    //时分转换日期
    formatDateTominute(dateStr) {
        if (dateStr == null || dateStr == "") {
            return "-"
        }
        var date = new Date(dateStr); //转换
        //重组
        var datetime =
            date.getFullYear() +
            "-" + //年
            (date.getMonth() + 1 > 9
                ? date.getMonth() + 1
                : "0" + (date.getMonth() + 1)) +
            "-" + //月
            //(date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + " " + date.getHours() + ":" + date.getMinutes(); //日
            (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + " " + (date.getHours()> 9 ? date.getHours() : "0" + date.getHours()) + ":" + (date.getMinutes()> 9 ? date.getMinutes() : "0" + date.getMinutes()) ; //日
        return datetime;
    },
    //时分秒转换日期
  formatDateToSeconds(dateStr) {
    if (dateStr == null || dateStr == "") {
      return "-";
    }
    var date = new Date(dateStr); //转换
    //重组
    var datetime =
      date.getFullYear() +
      "-" + //年
      (date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "-" + //月
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      " " +
      (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) +
      ":" +
      (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) +
      ":" +
      (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds()); //日
    return datetime;
  },
    addScrollTop(index,passKey) {
        let pageMap = store.state.stateObject.pageMap;
        let key = passKey||this.getQueryVariable("stack-key");
        let scrollTop = document.getElementsByClassName(
            "myScrollTop"
        )[0].scrollTop;
        if(index&&document.getElementsByClassName("myScrollTop")[index].scrollTop){
            scrollTop = document.getElementsByClassName("myScrollTop")[index].scrollTop;
        }
        if (pageMap == null) {
            pageMap = new Map();
        }
        console.log(JSON.stringify(pageMap));
        pageMap[key] = scrollTop;
        store.commit("stateFn", pageMap);
    },
    removeScrollTop(index,passKey) {
        let pageMap = store.state.stateObject.pageMap;
        let key = passKey||this.getQueryVariable("stack-key");
        if (pageMap == null) {
            return
        }
        console.log("removeScrollTop==" + pageMap[key]);
        if (!pageMap[key]) {
            return
        }
        if(index&&document.getElementsByClassName("myScrollTop")[index]){
            document.getElementsByClassName("myScrollTop")[index].scrollTop = pageMap[key];
        }else{
            document.getElementsByClassName(
                "myScrollTop"
            )[0].scrollTop = pageMap[key];
        }
        
        delete pageMap[key];
        store.commit("stateFn", pageMap);
    },
    getUserInfo() {
        return store.state.stateObject.userInfo;
    },
    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    isServiceCallSuccess(code) {
        if (code == "000000") {
            return true;
        } else {
            return false;
        }
    },
    showLoadingex(msg) {
        var loadingcontent = document.getElementById("loadingbg");
        if (loadingcontent) {
            loadingcontent.style.display = "";
            if (msg) {
                document.getElementById('loadingmsg').innerHTML = msg;
            }
        } else {
            loadingcontent = document.createElement("DIV");
            loadingcontent.id = "loadingbg";
            loadingcontent.classList = "loadingbar";
            //  loadingcontent.innerHTML = "<div class='loaddingLess'><img class='loadingimg' src='data:image/gif;base64,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' /><div id='loadingmsg' class='loadingmsg'>" + (msg ? msg : '') + "</div></div>";
            loadingcontent.innerHTML = "<div class='loaddingLess'><img class='loadingimg' src='data:image/gif;base64,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' /><div id='loadingmsg' class='loadingmsg'>" + (msg ? msg : '') + "</div></div>";
            document.body.appendChild(loadingcontent);
        }
    },
    showLoadingex2(msg) {
        var loadingcontent = document.getElementById("loadingbg");
        if (loadingcontent) {
            loadingcontent.style.display = "";
            if (msg) {
                document.getElementById('loadingmsg').innerHTML = msg;
            }
        } else {
            loadingcontent = document.createElement("DIV");
            loadingcontent.id = "loadingbg";
            loadingcontent.classList = "loadingbar";
            loadingcontent.innerHTML = "<div class='loaddingLess'><img class='loadingimg' src='data:image/gif;base64,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' /><div id='loadingmsg' class='loadingmsg'>" + (msg ? msg : '') + "</div></div>";
            document.body.appendChild(loadingcontent);
        }
    },
    showLoading(msg) {
        var loadingcontent = document.getElementById("loadingbg");
        if (loadingcontent) {
            loadingcontent.style.display = "";
            if (msg) {
                document.getElementById('loadingmsg').innerHTML = msg;
            }
        } else {
            loadingcontent = document.createElement("DIV");
            loadingcontent.id = "loadingbg";
            loadingcontent.classList = "loadingbar";
            loadingcontent.innerHTML = "<div class='loaddingLess'><img class='loadingimg img01' src=" +
                "'data:image/png;base64,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"
                + "' /><div id='loadingmsg' class='loadingmsg'>" + (msg ? msg : '') + "</div></div>";
            document.body.appendChild(loadingcontent);
        }
    },

    hidLoading() {
        var loadingBar = document.getElementById("loadingbg");
        if (loadingBar) {
            loadingBar.style.display = "none";
        }
    },
    //获取url参数
    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    getCurrentProjectId() {
        let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
        return thisProjectInfo.projectId;
    },
    getCurrentProjectName() {
        let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
        return thisProjectInfo.projectName;
    },
    getCurrentCustomerId() {
        return store.state.stateObject.customerId;
    },
    getLodingPic() {
        return "data:image/gif;base64,R0lGODlhIAAgALMAAP///7Ozs/v7+9bW1uHh4fLy8rq6uoGBgTQ0NAEBARsbG8TExJeXl/39/VRUVAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBQAAACwAAAAAIAAgAAAE5xDISSlLrOrNp0pKNRCdFhxVolJLEJQUoSgOpSYT4RowNSsvyW1icA16k8MMMRkCBjskBTFDAZyuAEkqCfxIQ2hgQRFvAQEEIjNxVDW6XNE4YagRjuBCwe60smQUDnd4Rz1ZAQZnFAGDd0hihh12CEE9kjAEVlycXIg7BAsMB6SlnJ87paqbSKiKoqusnbMdmDC2tXQlkUhziYtyWTxIfy6BE8WJt5YEvpJivxNaGmLHT0VnOgGYf0dZXS7APdpB309RnHOG5gDqXGLDaC457D1zZ/V/nmOM82XiHQjYKhKP1oZmADdEAAAh+QQFBQAAACwAAAAAGAAXAAAEchDISasKNeuJFKoHs4mUYlJIkmjIV54Soypsa0wmLSnqoTEtBw52mG0AjhYpBxioEqRNy8V0qFzNw+GGwlJki4lBqx1IBgjMkRIghwjrzcDti2/Gh7D9qN774wQGAYOEfwCChIV/gYmDho+QkZKTR3p7EQAh+QQFBQAAACwBAAAAHQAOAAAEchDISWdANesNHHJZwE2DUSEo5SjKKB2HOKGYFLD1CB/DnEoIlkti2PlyuKGEATMBaAACSyGbEDYD4zN1YIEmh0SCQQgYehNmTNNaKsQJXmBuuEYPi9ECAU/UFnNzeUp9VBQEBoFOLmFxWHNoQw6RWEocEQAh+QQFBQAAACwHAAAAGQARAAAEaRDICdZZNOvNDsvfBhBDdpwZgohBgE3nQaki0AYEjEqOGmqDlkEnAzBUjhrA0CoBYhLVSkm4SaAAWkahCFAWTU0A4RxzFWJnzXFWJJWb9pTihRu5dvghl+/7NQmBggo/fYKHCX8AiAmEEQAh+QQFBQAAACwOAAAAEgAYAAAEZXCwAaq9ODAMDOUAI17McYDhWA3mCYpb1RooXBktmsbt944BU6zCQCBQiwPB4jAihiCK86irTB20qvWp7Xq/FYV4TNWNz4oqWoEIgL0HX/eQSLi69boCikTkE2VVDAp5d1p0CW4RACH5BAUFAAAALA4AAAASAB4AAASAkBgCqr3YBIMXvkEIMsxXhcFFpiZqBaTXisBClibgAnd+ijYGq2I4HAamwXBgNHJ8BEbzgPNNjz7LwpnFDLvgLGJMdnw/5DRCrHaE3xbKm6FQwOt1xDnpwCvcJgcJMgEIeCYOCQlrF4YmBIoJVV2CCXZvCooHbwGRcAiKcmFUJhEAIfkEBQUAAAAsDwABABEAHwAABHsQyAkGoRivELInnOFlBjeM1BCiFBdcbMUtKQdTN0CUJru5NJQrYMh5VIFTTKJcOj2HqJQRhEqvqGuU+uw6AwgEwxkOO55lxIihoDjKY8pBoThPxmpAYi+hKzoeewkTdHkZghMIdCOIhIuHfBMOjxiNLR4KCW1ODAlxSxEAIfkEBQUAAAAsCAAOABgAEgAABGwQyEkrCDgbYvvMoOF5ILaNaIoGKroch9hacD3MFMHUBzMHiBtgwJMBFolDB4GoGGBCACKRcAAUWAmzOWJQExysQsJgWj0KqvKalTiYPhp1LBFTtp10Is6mT5gdVFx1bRN8FTsVCAqDOB9+KhEAIfkEBQUAAAAsAgASAB0ADgAABHgQyEmrBePS4bQdQZBdR5IcHmWEgUFQgWKaKbWwwSIhc4LonsXhBSCsQoOSScGQDJiWwOHQnAxWBIYJNXEoFCiEWDI9jCzESey7GwMM5doEwW4jJoypQQ743u1WcTV0CgFzbhJ5XClfHYd/EwZnHoYVDgiOfHKQNREAIfkEBQUAAAAsAAAPABkAEQAABGeQqUQruDjrW3vaYCZ5X2ie6EkcKaooTAsi7ytnTq046BBsNcTvItz4AotMwKZBIC6H6CVAJaCcT0CUBTgaTg5nTCu9GKiDEMPJg5YBBOpwlnVzLwtqyKnZagZWahoMB2M3GgsHSRsRACH5BAUFAAAALAEACAARABgAAARcMKR0gL34npkUyyCAcAmyhBijkGi2UW02VHFt33iu7yiDIDaD4/erEYGDlu/nuBAOJ9Dvc2EcDgFAYIuaXS3bbOh6MIC5IAP5Eh5fk2exC4tpgwZyiyFgvhEMBBEAIfkEBQUAAAAsAAACAA4AHQAABHMQyAnYoViSlFDGXBJ808Ep5KRwV8qEg+pRCOeoioKMwJK0Ekcu54h9AoghKgXIMZgAApQZcCCu2Ax2O6NUud2pmJcyHA4L0uDM/ljYDCnGfGakJQE5YH0wUBYBAUYfBIFkHwaBgxkDgX5lgXpHAXcpBIsRADs=";
    },
    getRoleInfo() {
        return store.state.stateObject.userInfo.roleList[0].roleLevel;
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
    //处理拓展端图片短路劲问题
    detailImgPath(url) {
        if (url.indexOf('http')) {
            url = "http://top-release.oss-cn-chengdu.aliyuncs.com/" + url;
        }
        return url;
    },
    //获取长时间格式
    getLongDate(dateTime) {
        if (dateTime) {
            return new Date(dateTime).Format("yyyy-MM-dd hh:mm:ss")
        } else {
            return null;
        }
    },
    //获取星期一时间
    getWeekOne() {
        var now = new Date();
        var nowTime = now.getTime();
        var day = now.getDay();
        var oneDayTime = 24 * 60 * 60 * 1000;
        var mondayTime = nowTime - (day - 1) * oneDayTime;
        return mondayTime;
    },
    //获取周末时间
    getWeekDate() {
        var now = new Date();
        var nowTime = now.getTime();
        var day = now.getDay();
        var oneDayTime = 24 * 60 * 60 * 1000;
        var SundayTime = nowTime + (7 - day) * oneDayTime;
        return SundayTime;
    },
    getMonthMax() {
        var date = new Date();
        var currentMonth = date.getMonth();
        var nextMonth = ++currentMonth;
        var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
        var oneDay = 1000 * 60 * 60 * 24;
        return new Date(nextMonthFirstDay - oneDay);
    },
    //获取本月第一天
    getMonthMin() {
        var nowDate = new Date();
        return nowDate.setDate(1);
    },
    //增值税发票识别
    getInfoByReceipt(baiduToken, url, succCallBack, failCallBack, urlType, type, isStop) {
        let that = this;
        let xhr = new XMLHttpRequest();
        xhr.timeout = 6000;
        xhr.open('POST', 'https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice?access_token=' + baiduToken, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState == 4) {
                //请求完成了
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
                    let ret = JSON.parse(xhr.response)
                    if (ret.words_result) {
                        if(ret.words_result.PurchaserRegisterNum&&ret.words_result.PurchaserRegisterNum=="91420106MADMODGT5F"){
                            //O转0
                            ret.words_result.PurchaserRegisterNum="91420106MADM0DGT5F"
                        }
                         try {
                            if(ret.words_result.InvoiceNumConfirm&&ret.words_result.InvoiceNumConfirm.length>ret.words_result.InvoiceNum.length){
                                ret.words_result.InvoiceNum=ret.words_result.InvoiceNumConfirm;
                            }
                            ret.words_result.buyCompanyName=ret.words_result.PurchaserName||'';
                            ret.words_result.salesCompanyName=ret.words_result.SellerName||'';
                            ret.words_result.taxMoney=ret.words_result.TotalTax||0;
                            ret.words_result.invoiceWarehouseInvoiceType=ret.words_result.InvoiceTypeOrg||"";
                            ret.words_result.billingDate = ret.words_result.InvoiceDate || ""; 
                            ret.words_result.businessType = ret.words_result.ServiceType||"";
                            ret.words_result.salesTaxpayerCode = ret.words_result.SellerRegisterNum||"";

                        } catch (error) {}
                        succCallBack && succCallBack(ret.words_result);
                    } else {
                        if (!isStop) {
                            that.getInfoByReceipt(baiduToken, url, succCallBack, failCallBack, urlType, "roll", true);
                        } else {
                            failCallBack && failCallBack("发票识别失败,已保存图片！");
                        }
                        return false
                    }
                }
            }
        }
        xhr.ontimeout = xhr.onerror = err => {
            failCallBack && failCallBack("请网络环境不好,请稍切换网络试试！")
        };
        if (urlType == "pdf_file") {
            var formData = new FormData();
            formData.append("type", type || "normal");
            formData.append("pdf_file", url);
            xhr.send(formData);
        } else {
            // xhr.send("url=" + url + "&type=" + (type || "normal"));
            xhr.send("image=" + encodeURIComponent(url) + "&type=" + (type || "normal"));
        }

    },

    
//增值税发票识别(升级版)
// vat_invoice	增值税发票
// taxi_receipt	出租车票
// train_ticket	火车票
// quota_invoice	定额发票
// air_ticket	飞机行程单
// roll_normal_invoice	卷票
// printed_invoice	机打发票
// bus_ticket	汽车票
// toll_invoice	过路过桥费发票
// ferry_ticket	船票
// motor_vehicle_invoice	机动车销售发票
// used_vehicle_invoice	二手车发票
// taxi_online_ticket	网约车行程单
// limit_invoice	限额发票
// shopping_receipt	购物小票
// pos_invoice	POS小票
// others	其他
getInfoByReceiptPlus (baiduToken, url, succCallBack, failCallBack, urlType, type, isStop,invoiceType) {
    let that = this;
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open('POST', 'https://aip.baidubce.com/rest/2.0/ocr/v1/multiple_invoice?access_token=' + baiduToken, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('Accept', 'application/json');
    
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          let ret = JSON.parse(xhr.response)
          if (ret.words_result&&ret.words_result.length>0) {
            let retData={} 
            if(ret.words_result[0].type=='train_ticket'){
              retData={
                AmountInFiguers:that.getFloats(ret.words_result[0].result.ticket_rates[0].word),
                InvoiceNum:ret.words_result[0].result.invoice_num[0].word,
                PurchaserRegisterNum:ret.words_result[0].result.purchaser_register_num[0].word,
                PurchaserName:ret.words_result[0].result.purchaser_name[0].word,
                buyCompanyName:ret.words_result[0].result.purchaser_name[0].word||'',
                taxMoney:0,
                invoiceWarehouseInvoiceType:"",
                billingDate: ret.words_result[0].result.invoice_date[0].word,
                businessType: ret.words_result[0].result.ServiceType[0].word,
                salesTaxpayerCode: "",
              }
            }else if (ret.words_result[0].type == "air_ticket") {
              retData={
                AmountInFiguers:that.getFloats(ret.words_result[0].result.ticket_rates[0].word),
                InvoiceNum:ret.words_result[0].result.invoice_num[0].word,
                PurchaserRegisterNum:ret.words_result[0].result.purchaser_register_num[0].word,
                PurchaserName:ret.words_result[0].result.purchaser_name[0].word,
                buyCompanyName:ret.words_result[0].result.purchaser_name[0].word||'',
                taxMoney:0,
                invoiceWarehouseInvoiceType:"",
                billingDate:ret.words_result[0].result.start_date[0].word,
                businessType:ret.words_result[0].result.ServiceType[0].word,
                salesCompanyName:ret.words_result[0].result.issued_by[0].word||'',
              }
            }

            if(retData.AmountInFiguers&&retData.InvoiceNum){
                if(retData.PurchaserRegisterNum&&retData.PurchaserRegisterNum=="91420106MADMODGT5F"){
                    //O转0
                    retData.PurchaserRegisterNum="91420106MADM0DGT5F"
                }
              succCallBack && succCallBack(retData);
            }else{
              failCallBack && failCallBack("票据类型匹配有误,请换一张发票！");
            }
          } else {
            if (!isStop) {
                that.getInfoByReceiptPlus(baiduToken, url, succCallBack, failCallBack, urlType, "roll", true,invoiceType);
            } else {
              failCallBack && failCallBack("不能识别的图片,请换一张发票！");
            }
            return false
          }
        }
      }
    }
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("请求接口失败,请稍后再试！")
    };
    if (urlType == "pdf_file") {
      xhr.send("pdf_file=" + encodeURIComponent(url) + "&type=" + (type || "normal"));
      // return
      // var formData = new FormData();
      // formData.append("type", type || "normal");
      // formData.append("pdf_file",encodeURIComponent( url));
      // formData.append("verify_parameter",'false');
      // formData.append("probability",'false');
      // formData.append("location",'false');
      // console.log(url);
      // xhr.send(formData);
    } else {
      // xhr.send("url=" + url + "&type=" + (type || "normal"));
      xhr.send("image=" + encodeURIComponent(url) + "&type=" + (type || "normal"));
    }
  },
  
  getFloats(str){
    // 正则表达式匹配浮点数
    const floatRegex = /[-+]?\d*\.\d+|\d+(\.\d+)?([eE][-+]?\d+)?/g;
    // 匹配字符串中的所有浮点数并将它们转换为数值
    const floats = str.match(floatRegex).map(Number);
    return floats[0];
  },
  getInfoByReceiptCommon (baiduToken, url, succCallBack, failCallBack, urlType, type, isStop,invoiceType) {
    if(invoiceType=='2'||invoiceType=='3'){
      this.getInfoByReceiptPlus(baiduToken, url, succCallBack, failCallBack, urlType, type, isStop,invoiceType)
    }else{
      this.getInfoByReceipt(baiduToken, url, succCallBack, failCallBack, urlType, type, isStop)
    }
  },
  
    //获取文件名称
    getFileName(url, appLocal) {
        let arry1 = url.split('/');
        let str1 = arry1[arry1.length - 1];
        let arry2 = str1.split('.');
        let typeLength = arry2[arry2.length - 1].length;//类型长度不一致
        let retStr = str1.substring(0, str1.length - typeLength - 37);
        try {
            retStr = decodeURIComponent(retStr);
        } catch (error) {
            retStr = "附件"
        }

        if (retStr == "" || appLocal) {
            let splitStr = str1.indexOf('_');
            retStr = str1.substring(splitStr + 1, str1.length);
            return retStr;
        }
        return retStr + "." + arry2[arry2.length - 1];
    },
    checkTokenRefresh() {
        if (!store.state.stateObject.getTokening) {
            let obj = {newToken:""};
            store.commit("stateFn2", obj);
            store.state.stateObject.getTokening = true;
            api
                .refreshToken()
                .then((res) => {
                    if (res.data) {
                        store.state.stateObject.tokenRefreshTime = new Date();
                        let tempUserInfo = store.state.stateObject.userInfo;
                        tempUserInfo.token = res.data;
                        let obj = {
                            userInfo: tempUserInfo,
                            getTokening: false,
                            newToken:res.data
                        };
                        store.commit("stateFn2", obj);
                        utilsObj.saveLocation("userInfo", JSON.stringify(tempUserInfo));
                        utilsObj.saveLocation("token", tempUserInfo.token);
                    }
                })
                .catch((err) => {
                    let obj = {
                        getTokening: false
                    };
                    store.commit("stateFn2", obj);
                });
        }
    },
    logout(msg) {
        Dialog.confirm({
            title: "温馨提示",
            message: msg + "，需要重新登录?",
            showCancelButton: false
        })
            .then(() => {
                SXApi.call(null, null, "FunctionPlugin", "logout", null);
                localStorage.setItem("thisProjectInfo", "");
                utilsObj.saveLocation("thisProjectInfo", "");
            })
            .catch(() => {
                // on cancel
                store.state.stateObject.alertOut = false;
            });


    },
    fileLoad(url) {
        SXApi.call(
            function (suc) { },
            null,
            "FunctionPlugin",
            "download_look_file",
            {
                url: url,
                isOpen: "0"
            }
        );
    },
    //人脸识别
    faceRecognition(baiduToken, base1, base2, succCallBack, failCallBack) {
        let that = this;
        let xhr = new XMLHttpRequest();
        xhr.timeout = 6000;
        xhr.open('POST', 'https://aip.baidubce.com/rest/2.0/face/v3/match?access_token=' + baiduToken, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        //    xhr.responseType="json";
        //   xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
        xhr.onreadystatechange = () => {
            if (xhr.readyState == 4) {
                //请求完成了
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
                    let ret = JSON.parse(xhr.response)
                    if (ret.result) {
                        succCallBack && succCallBack(ret.result);
                    } else {
                        that.hidLoading();
                        // if (!isStop) {
                        //     that.faceRecognition(baiduToken, url, succCallBack, failCallBack, urlType, "roll", true);
                        // } else {
                        if (ret.error_code == 223120) {
                            failCallBack && failCallBack("图片较为模糊请重拍！");
                        } else if (ret.error_code == 222202) {
                            failCallBack && failCallBack("图片中没有人脸！");
                        }
                        else {
                            failCallBack && failCallBack("图片识别不了请重试！" + ret.error_code);
                        }
                        // }
                        return false
                    }
                }
            }
        }
        xhr.ontimeout = xhr.onerror = err => {
            failCallBack && failCallBack("请网络环境不好,请稍切换网络试试！")
        };


        let post = [
            {
                "image": base1,
                "image_type": "BASE64",
                "face_type": "LIVE",
                "liveness_control": "HIGH"
            },
            {
                "image": base2,
                "image_type": "BASE64",
                "face_type": "LIVE",
                "liveness_control": "HIGH"
            },
        ]
        xhr.send(JSON.stringify(post));
    },

    //人脸识别-底图url，拍照base64
    faceRecognition2(baiduToken, url, base2, succCallBack, failCallBack) {
        let that = this;
        let xhr = new XMLHttpRequest();
        xhr.timeout = 6000;
        xhr.open('POST', 'https://aip.baidubce.com/rest/2.0/face/v3/match?access_token=' + baiduToken, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        //    xhr.responseType="json";
        //   xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
        xhr.onreadystatechange = () => {
            if (xhr.readyState == 4) {
                //请求完成了
                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
                    let ret = JSON.parse(xhr.response)
                    if (ret.result) {
                        succCallBack && succCallBack(ret.result);
                    } else {
                        that.hidLoading();
                        // if (!isStop) {
                        //     that.faceRecognition(baiduToken, url, succCallBack, failCallBack, urlType, "roll", true);
                        // } else {
                        if (ret.error_code == 223120) {
                            failCallBack && failCallBack("图片较为模糊请重拍！");
                        } else if (ret.error_code == 222202) {
                            failCallBack && failCallBack("图片中没有人脸！");
                        }
                        else {
                            failCallBack && failCallBack("图片识别不了请重试！" + ret.error_code);
                        }
                        // }
                        return false
                    }
                }
            }
        }
        xhr.ontimeout = xhr.onerror = err => {
            failCallBack && failCallBack("网络环境不好,请稍切换网络试试！")
        };


        let post = [
            {
                "image": url,
                "image_type": "URL",
                "face_type": "LIVE",
                "liveness_control": "HIGH"
            },
            {
                "image": base2,
                "image_type": "BASE64",
                "face_type": "LIVE",
                "liveness_control": "HIGH"
            },
        ]
        xhr.send(JSON.stringify(post));
    },
    //语音转文字
    openVoiceInput(succCallBack) {
        
        let that = this;
        SXApi.call(
            function (suc) {
                if (suc.data.content) {
                    succCallBack && succCallBack(suc.data.content);
                }
            },
            function (err) { },
            "FunctionPlugin",
            "openVoiceInput",
            null
        );
    },
    //埋点-EventId:页面名称
    talkingDataFunc(EventId) {
        try {
            if(process.env.TalkingData&&(EventId=="面谈分析"||EventId=="获取面谈录音生成项目实勘数据")){
                TDAPP.onEvent(EventId);
            }
        } catch (error) { }
    },
    getNonCooperationReasonMap() {
        return [
            { name: "已签约", val: 1 },
            { name: "没有找到关键人", val: 2 },
            { name: "价格没有谈拢", val: 3 },
            { name: "甲乙双方条件无法达成一致", val: 4 },
            { name: "甲方有合作方", val: 5 },
            { name: "甲方遗留问题未处理(抵押、查封、无预售许可证)", val: 6 },
            { name: "暂时不卖", val: 7},
            { name: "已售完", val: 8}
        ]
    },
    //项目价值模块整合star--------------------------------------------------------------------------------------------------------------------
    //获取项目价值map
    // getProjectValueMapEx() {
    //     return [
    //         { name: "一类项目", val:"0-1"  },
    //         { name: "二类项目-安置", val:"1-2"  },
    //         { name: "二类项目-查封", val:"1-3"  },
    //         { name: "二类项目-法拍", val:"1-4"  },
    //         { name: "三类项目-清盘", val:"2-5"  },
    //         { name: "三类项目-项目无车位", val:"2-6"  },
    //     ]
    // },
    //获取项目价值map
    getProjectValueMap() {
        // return ["一类项目","二类项目-安置","二类项目-查封","二类项目-法拍","三类项目-清盘","三类项目-项目无车位"]
        return ["一类项目","二类项目","三类项目"]
    },
    //获取项目价值map
    getProjectValueByMap() {
        return ["0-1","1-2","1-3","1-4","2-5","2-6"]
    },
    //获取项目价值
    getProjectValue(bigType,cheildType){
        let bigMap=["一类项目","二类项目","三类项目"];
        let cheildMap=["","","安置","查封","法拍","清盘","项目无车位"];
        let ret="";
        if(bigMap[bigType]||cheildMap[cheildType]){
            ret=bigMap[bigType]+(cheildMap[cheildType]?("-"+cheildMap[cheildType]):'');
        }
        return ret;
    },
    //项目价值模块整合end--------------------------------------------------------------------------------------------------------------------
    //利好利空
    getGoodOrBearishMap(key) {
        let bearishData=[
        {
          text: "不能销售人防车位数量与未售车位总数（含人防）占比",
          standard: "25%",
          value:"1"
        },
        {
          text: "特殊车型或人防车位低价售卖宣传渗透度",
          standard: "成交比例超过10%，或成交超过20个",
          value:"2"
        },
        {
          text: "抵工程款且低价卖车位",
          standard: "",
          value:"3"
        },
        {
          text: "开发商或物业涨租金失败（预示着小区业主习惯了抱团抵制开发商及物业的各项工作）若出现此情况就需要安排正式经理级别以上打盘",
          standard: "",
          value:"4"
        },
        {
          text: "开发商不同意非标准车位降价或位置置换销售",
          standard: "剩余可售正常车位低于本次的保底任务数量",
          value:"5"
        },
        {
          text: "小区业主销售期间要换物业公司",
          standard: "",
          value:"6"
        },
        {
          text: "小区老板住在小区内",
          standard: "",
          value:"7"
        },
        {
          text: "我方项目比周边同品质楼盘车位价格高",
          standard: "成都主城区高2万及以上，其他区域高1万及以上",
          value:"8"
        },
        {
          text: "开发商卖房或卖车位赠送过车位、车位抵用券、管理费抵扣券等促销手段，我方无法继续使用前期政策",
          standard: "",
          value:"9"
        },
        {
          text: "商住一体项目，商业车位能替代住宅停车",
          standard: "",
          value:"10"
        },
        {
          text: "因股东分家导致打价格战",
          standard: "剩余车位有两家及以上股东在售卖",
          value:"11"
        },
        {
          text: "车位距离太远，电梯不能直达",
          standard: "超过300米",
          value:"12"
        },
        {
          text: "小区是否有业主抱团闹事的风险：刺头业主",
          standard: "",
          value:"13"
        },
        {
          text: "人防（或微型）车位过去是否卖过低价",
          standard: "",
          value:"14"
        },
        {
          text: "小区地面有大量车位可以随便停",
          standard: "",
          value:"15"
        },
        {
          text: "高层正对下方的停车位，本次可售车位较少",
          standard: "",
          value:"16"
        },
        {
          text: "业主签了回购协议的，或者有还租的情况",
          standard: "",
          value:"17"
        },
        {
          text: "物业可能存在干扰销售的情况(需要填写在利空内)",
          standard: "",
          value:"18"
        },
        {
          text: "旁边楼盘卖的便宜的",
          standard: "",
          value:"19"
        },
        {
          text: "周围有可替代停车场",
          standard: "",
          value:"20"
        },
        {
          text: "项目集中打盘并且卖了批量低价",
          standard: "",
          value:"21"
        },
        {
          text: "外面几百辆车子没有进到地下室是利空",
          standard: "",
          value:"22"
        },
        ]
        let subGoodData= [
        {
          text: "以前不能办产权，现在可以办产权车位数量；",
          standard: "超过50个",
          value:"1"
        },
        {
          text: "以前查封车位重新销售或新增加了可售车位源数量",
          standard: "超过50个",
          value:"2"
        },
        { text: "有高价抵款车位", standard: "高2万以上" ,value:"3"},
        { text: "销售前3个月大型商业品牌入驻", standard: "",value:"4" },
        {
          text: "我方项目比周边同品质楼盘车位价格低",
          standard: "成都主城区低2万及以上，其他区域低1万及以上",
          value:"5"
        },
        {
          text: " 开发商及第三方卖房或卖车位赠送过车位抵用券、管理费抵扣券等促销手段，我方现在可以继续使用前期政策",
          standard: "",
          value:"6"
        },
        { text: "开发商或物业成功涨租金", standard: "涨价超30元以上",value:"7" },
        {
          text: "开发商同意非标准车位降价或位置置换销售",
          standard: "超过或等于保底任务数量",
          value:"8"
        },
        {
          text: "产权车位可以置换人防车位及机械车位，（在产权车位位置不好的情况下开发商可以同意进行置换）",
          standard: "开发公司必须协议盖章",
          value:"9"
        },
        { text: "政府部门销售期间做外围整治车辆数量", standard: "超过50个",value:"10" },
        {
          text: "项目在大量老小区的范围内，外围无法停车、停车紧张的，可以多定任务量",
          standard: "",
          value:"11"
        },
        ]
        return key==1?subGoodData:bearishData;
    },
    //复制
    copyContent(str){
    // 复制 
    // 数字没有 .length 不能执行selectText 需要转化成字符串
      const textString = str;
      let input = document.querySelector("#copy-input");
      if (!input) {
        input = document.createElement("input");
        input.id = "copy-input";
        input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input);
      }
      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      this.selectText(input, 0, textString.length);
      document.execCommand("copy")
    },
    selectText(textbox, startIndex, stopIndex) {
      if (textbox.createTextRange) {
        // ie
        const range = textbox.createTextRange();
        range.collapse(true);
        range.moveStart("character", startIndex); // 起始光标
        range.moveEnd("character", stopIndex - startIndex); // 结束光标
        range.select(); // 不兼容苹果
      } else {
        // firefox/chrome
        textbox.setSelectionRange(startIndex, stopIndex);
        textbox.focus();
      }
    },
    //获取资源类型释义
    getresourceTypeMapArry() {
        //["开发商", "物业", "三方渠道", "公司发展", "私事","金融法拍方","法拍相关","抵款方"]
        return ["开发商", "物业", "三方渠道", "", "其他","金融法拍方","","抵款方"];
    },
    //判断关键人自拓未面谈
    getKeyPersonSelfDevFace(item){
        let ret="";
        if(((item.resourceRole&&item.resourceRole.indexOf('关键人')!=-1)||item.tagId=='48')&&item.resourceSource=='1'&&(!item.interviewCount||item.interviewCount=='0')){
            ret="<span class='iconfont iconwenhao-xianxingyuankuang' style='font-size: 12px;'></span>";
        }
        return ret;
    },
    //操作本地录音
    localAudioSet(callback,sceneId) {
        if(sceneId){
            localStorage.setItem("localAudioStuteSceneId", sceneId);
        }
        SXApi.call(
            function (suc) { 
                localStorage.setItem("localAudioStute", suc.data.state);
                callback&&callback(suc);    
            },
            null,
            "FunctionPlugin",
            "openRecord",
            {sceneId:sceneId||localStorage.getItem("localAudioStuteSceneId")}
            // sceneId?{sceneId:sceneId}:{}
        );
    },
    //获取商机等级 0=无商机 1=一有 2=二有 3=三有一级商机 4=三有二级商机 5=三有三级商机 6=四有二级商机 7=四有三级商机
    getBusinessLevelMapVer2(){
        return [
            {name:"无",text:"无",value:0},
            {name:"一有",text:"一有",value:1},
            {name:"二有",text:"二有",value:2},
            {name:"三有",text:"三有",value:3},
            // {name:"三有二级",text:"三有二级",value:4},
            // {name:"三有三级",text:"三有三级",value:5},
            {name:"四有二级",text:"四有二级",value:6},
            {name:"四有三级",text:"四有三级",value:7}
        ];
    },
    getBusinessLevelMapVer2Edit(){
        return [
            // {name:"三有一级(无匹配无意向)",value:3},
            // {name:"三有二级(无匹配等机会)",value:4},
            // {name:"三有三级(无匹配有意向)",value:5},
            {name:"二有(无意向)",value:2},
            {name:"三有(无匹配有意向)",value:3},
            {name:"四有二级(有匹配等机会)",value:6},
            {name:"四有三级(有匹配有意向)",value:7}
        ];
    },
    getBusinessLevelTypeScoreMap(nowLeave,sureLeave) {
        let scoreDimensionMap=[
            {label:"四有二级",value:1,baseScore:25,isSpaceAdd:true},
            {label:"四有三级",value:2,baseScore:50,isSpaceAdd:true},
            {label:"项目评估",value:3,baseScore:50,isSpaceAdd:true},
            {label:"正式商务条款",value:4,baseScore:50,isSpaceAdd:true},
            {label:"新客户新签",value:5,baseScore:600,isSpaceAdd:false},
            {label:"老客户新签",value:6,baseScore:400,isSpaceAdd:false},
            {label:"老客户续签",value:7,baseScore:200,isSpaceAdd:false},
        ]
        let ret="";
        let score=0;
        let nowLeaveIndex=-1;
        let sureLeaveIndex=-1;
        scoreDimensionMap.forEach((element,index)=>{
            if(sureLeave==element.value){
            ret=element.label;
            score=element.baseScore;
            sureLeaveIndex=index;
            }
            if(nowLeave==element.value){
            nowLeaveIndex=index;
            }
        })
        if(sureLeaveIndex>-1&&sureLeaveIndex>nowLeaveIndex&&nowLeaveIndex>-1){
            for(let i=nowLeaveIndex;i<sureLeaveIndex;i++){
            if(scoreDimensionMap[i].isSpaceAdd){
                score=score+scoreDimensionMap[i].baseScore;
            }
            }
        }
        if(sureLeaveIndex>-1&&nowLeaveIndex>-1&&sureLeaveIndex<nowLeaveIndex){
            score=0;
        }
        // let reult="";
        // if(ret){
        //     reult=ret+("+"+score+"分");
        // }
        return ret;
    },
    //保存手机本地日志
    saveLocaMessage(value) {
      try {
        SXApi.call(function (suc) {
        }, null, "FunctionPlugin", "write_log", {
          message: value
        });
      } catch (error) {}
    },
    //聚合类型Map
     getLabelGradeText(){
        return [
            {name:"T0.立即跟进",value:"A"},
            {name:"T3.每季度",value:"B"},
            {name:"T6-1.每半年",value:"C"},
            {name:"T6-2.每半年",value:"D"},
            {name:"T6-3.每半年",value:"E"},
            {name:"T6-4.每半年",value:"F"},
            {name:"T2.每2个月",value:"G"}
        ];
    },

}



// WEBPACK FOOTER //
// ./src/commonjs/common.js